import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "avatar primary--text" }
const _hoisted_2 = {
  key: 1,
  class: "pr-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pa-1' : 'pa-2')
  }, _createSlots({
    default: _withCtx(() => [
      (_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('click:all'))),
            "no-gutters": "",
            class: "d-flex justify-center w-100"
          }, {
            default: _withCtx(() => [
              (!_ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    class: "oss-card oss-card-left-part oss-card-icon-part"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_skeleton_loader, {
                        type: "avatar",
                        style: {"margin":"8px"}
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, {
                class: _normalizeClass(
                    _ctx.$vuetify.display.mobile
                        ? 'oss-card oss-card-left-part col-9 py-5'
                        : 'oss-card col-8 pa-5'
                )
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_skeleton_loader, { type: "text" })
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '3' : '2',
                class: "py-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_skeleton_loader, { type: "text" })
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.double)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_row, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emit('click:all'))),
                    "no-gutters": "",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.$vuetify.display.mobile && _ctx.icon)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            class: "oss-card oss-card-left-part oss-card-icon-part"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: _ctx.iconColor,
                                class: "oss-card-icon",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emit('click:icon')), ["stop"])),
                                size: "x-large"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.icon), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.$vuetify.display.mobile && _ctx.txtIcon)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            class: "oss-card oss-card-left-part oss-card-icon-part"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.txtIcon), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, {
                        class: _normalizeClass(
                            _ctx.$vuetify.display.mobile || (!_ctx.icon && !_ctx.txtIcon)
                                ? 'oss-card oss-card-left-part col-9'
                                : 'oss-card col-8 d-flex align-center flex-shrink-1 flex-grow-0'
                        )
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "left")
                        ]),
                        _: 3
                      }, 8, ["class"]),
                      _createVNode(_component_v_col, {
                        cols: _ctx.$vuetify.display.mobile ? '3' : '2',
                        class: "d-flex align-center justify-center flex-shrink-0 flex-grow-1"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.right)
                            ? _renderSlot(_ctx.$slots, "right", { key: 0 })
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (!!_ctx.amount)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.$vuetify.display.mobile)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12",
                                              class: _normalizeClass(
                                            'd-flex align-center justify-end py-2 ' + _ctx.amountStyle
                                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  style: {"min-width":"94px"},
                                                  class: _normalizeClass(
                                                _ctx.amount < 0
                                                    ? 'new_red--text text-right'
                                                    : 'secondary--text text-right'
                                            )
                                                }, _toDisplayString(isNaN(_ctx.amount)
                                                    ? "-"
                                                    : _ctx.newCommonFormatCurrency(_ctx.amount, undefined)), 3)
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                          : (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              cols: "12",
                                              class: _normalizeClass(
                                            'd-flex align-center justify-center py-2 ' + _ctx.amountStyle
                                        )
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  style: {"min-width":"120px"},
                                                  class: _normalizeClass(
                                                _ctx.amount < 0
                                                    ? 'new_red--text text-center'
                                                    : 'secondary--text text-center'
                                            )
                                                }, _toDisplayString(isNaN(_ctx.amount)
                                                    ? "-"
                                                    : _ctx.newCommonFormatCurrency(_ctx.amount, undefined)), 3)
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!!_ctx.tagText)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 1,
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: _normalizeClass(
                                        _ctx.$vuetify.display.mobile
                                            ? 'd-flex align-center justify-end py-2'
                                            : 'd-flex align-center justify-end py-2'
                                    ),
                                          style: _normalizeStyle(
                                        _ctx.$vuetify.display.mobile
                                            ? 'min-width: 94px'
                                            : 'min-width: 120px'
                                    )
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              class: _normalizeClass(_ctx.tagStyle),
                                              color: _ctx.tagColor,
                                              rounded: _ctx.roundedTag,
                                              outlined: _ctx.outlinedTag,
                                              fab: _ctx.fabTag,
                                              "x-small": _ctx.$vuetify.display.mobile,
                                              small: !_ctx.$vuetify.display.mobile,
                                              block: !_ctx.$vuetify.display.mobile,
                                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                                            _ctx.unclickableTag ? _ctx.emit('click:all') : _ctx.emit('click:tag')
                                        ), ["stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.tagText), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["class", "color", "rounded", "outlined", "fab", "x-small", "small", "block"])
                                          ]),
                                          _: 1
                                        }, 8, ["class", "style"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!!_ctx.tagIcon)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 2,
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: _normalizeClass(
                                        _ctx.$vuetify.display.mobile
                                            ? 'd-flex align-center justify-end py-2'
                                            : 'd-flex align-center justify-end py-2'
                                    ),
                                          style: _normalizeStyle(
                                        _ctx.$vuetify.display.mobile
                                            ? 'min-width: 94px'
                                            : 'min-width: 120px'
                                    )
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              class: _normalizeClass(_ctx.tagStyle),
                                              color: _ctx.tagColor,
                                              rounded: _ctx.roundedTag,
                                              outlined: _ctx.outlinedTag,
                                              fab: _ctx.fabTag,
                                              "x-small": _ctx.$vuetify.display.mobile,
                                              small: !_ctx.$vuetify.display.mobile,
                                              block: !_ctx.$vuetify.display.mobile,
                                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                                            _ctx.unclickableTag ? _ctx.emit('click:all') : _ctx.emit('click:tag')
                                        ), ["stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.tagIcon), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class", "color", "rounded", "outlined", "fab", "x-small", "small", "block"])
                                          ]),
                                          _: 1
                                        }, 8, ["class", "style"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        _: 3
                      }, 8, ["cols"])
                    ]),
                    _: 3
                  }),
                  (_ctx.$vuetify.display.mobile)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_divider)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emit('click:all')))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile && _ctx.icon)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          class: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: _ctx.iconColor,
                              class: "oss-card-icon",
                              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.emit('click:icon')), ["stop"])),
                              size: "x-large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.icon), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_col, {
                      class: _normalizeClass(
                        _ctx.$vuetify.display.mobile || !_ctx.icon
                            ? 'oss-card oss-card-full-part'
                            : 'oss-card oss-card-right-part'
                    )
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                }))
          ], 64))
    ]),
    _: 2
  }, [
    (_ctx.actionsPart)
      ? {
          name: "right",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "actions")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class"]))
}